import React from 'react';

import WidgetInput from './WidgetInput';

import PropsStatic from './interfaces/PropsStaticInterface';

export default class WidgetDetails extends WidgetInput<PropsStatic> {
    trustedHtml(val: string) {
        return { __html: val };
    }

    render() {
        const closeEleSmall = React.createElement(
            'button',
            {
                className: 'closeSmall',
                type: 'button',
                onClick: () => {
                    const dialog = document.getElementById(this.props.id) as HTMLDialogElement;
                    dialog.close();
                },
            },
            '×'
        );
        const closeEleBig = React.createElement('button', {
            className: 'closeBig',
            type: 'button',
            onClick: () => {
                const dialog = document.getElementById(this.props.id) as HTMLDialogElement;
                dialog.close();
            },
            dangerouslySetInnerHTML: this.trustedHtml(this.props.labelClose ?? '×'),
        });
        const dialogHeader = React.createElement('h3', {}, this.props.title);
        const dialogContent = React.createElement('div', {
            dangerouslySetInnerHTML: this.trustedHtml(this.props.text),
        });
        const lineEle = React.createElement('hr');
        const dialogEle = React.createElement(
            'dialog',
            {
                autofocus: true,
                id: this.props.id,
                className: this.props.class || '',
            },
            closeEleSmall,
            dialogHeader,
            dialogContent,
            lineEle,
            closeEleBig
        );
        const buttonEle = React.createElement(
            'button',
            {
                className: 'extraInfoOpen',
                type: 'button',
                title: this.props.label,
                onClick: () => {
                    const dialog = document.getElementById(this.props.id) as HTMLDialogElement;
                    dialog.showModal();
                    dialog.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center',
                    });
                    dialog.scrollTo({
                        behavior: 'smooth',
                        top: 0,
                    });
                },
            },
            '?'
        );

        return React.createElement(
            'div',
            {
                className: 'extraInfoWrapper',
            },
            buttonEle,
            dialogEle
        );
    }
}
